export default "__VITE_ASSET__823683e7__"